import VerticalVial from "./VerticalVial";

export default VerticalVial;